import { Box } from "@mui/material";
import SearchInput from "../searchInput/searchInput.component";
import FieldNotesSelect from "../select/fieldNotesSelect.component";
import FieldNotesFilterDate from "./fieldNotesFilterDates.component";
import UnderlineButton from "../buttons/underlineButton.component";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchFieldNotesStart } from "../../store/features/fieldNotes/fieldNotesSlice";
import dayjs from "dayjs";

const FieldNotesFilterSection = ({
  isMobile,
  onFiltersChange,
  selectValue,
  setSelectValue,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  searchQuery,
  setSearchQuery,
  fieldId,
}) => {
  const dispatch = useDispatch();
  const searchTimeoutRef = useRef();

  const handleSearchChange = useCallback(
    (value) => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      searchTimeoutRef.current = setTimeout(() => {
        setSearchQuery(value);
      }, 500);
    },
    [setSearchQuery],
  );

  const handleResetFilter = () => {
    setSelectValue("");
    setStartDate(null);
    setEndDate(null);
    setSearchQuery("");

    dispatch(fetchFieldNotesStart({}));
  };

  useEffect(() => {
    const filters = {};
    let hasActiveFilters = false;

    if (searchQuery) {
      filters.description = searchQuery;
      hasActiveFilters = true;
    }

    if (selectValue) {
      filters.type = selectValue;
      hasActiveFilters = true;
    }

    if (startDate || endDate) {
      const formattedStartDate =
        startDate && dayjs(startDate).isValid()
          ? dayjs(startDate).format("YYYY-MM-DD")
          : "";
      const formattedEndDate =
        endDate && dayjs(endDate).isValid()
          ? dayjs(endDate).format("YYYY-MM-DD")
          : "";

      filters.dates = [formattedStartDate, formattedEndDate];
      hasActiveFilters = true;
    }

    if (fieldId) {
      filters.field = fieldId;
      hasActiveFilters = true;
    }

    if (onFiltersChange) {
      onFiltersChange(hasActiveFilters);
    }

    dispatch(fetchFieldNotesStart(filters));
  }, [
    searchQuery,
    dispatch,
    onFiltersChange,
    selectValue,
    startDate,
    endDate,
    fieldId,
  ]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Box
      display="flex"
      width="100%"
      height="100%"
      flexDirection={isMobile ? "column" : "row"}
      gap={3}
    >
      <SearchInput
        placeholder="Cerca descrizione"
        onSearch={handleSearchChange}
        value={searchQuery}
      />
      <FieldNotesSelect value={selectValue} onChange={setSelectValue} />
      <FieldNotesFilterDate
        isMobile={isMobile}
        startDate={startDate}
        endDate={endDate}
        onStartChange={setStartDate}
        onEndChange={setEndDate}
      />
      <UnderlineButton
        label="Reset filtri"
        color="inherit"
        onClick={handleResetFilter}
      />
    </Box>
  );
};

export default FieldNotesFilterSection;
